import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import classes from "./JobOfferPage.module.css";
import { useParams } from "react-router";
import BackButton from "../../common/BackButton";
import { getJobOfferById } from "../../../api/firestoreData";
import ScreenAlert from "../../common/ScreenAlert/ScreenAlert";
import LoaderScreen from "../../common/LoaderScreen/LoaderScreen";
import JobOfferDescription from "./JobOfferDescription/JobOfferDescription";

function JobOfferPage() {
  const [jobOffer, setJobOffer] = useState(null);
  const { id } = useParams();
  useEffect(() => {
    getJobOfferById(id).then((res) => {
      setJobOffer(res);
    });
  }, [id]);
  if (jobOffer === undefined) {
    return (
      <ScreenAlert
        severity="error"
        fontSize={50}
        message="Vyskytla sa chyba pri vyhľadaní danej pracovnej ponuky"
      />
    );
  }
  return (
    <>
      <BackButton />
      {jobOffer ? (
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          className={classes.grid}
        >
          <Grid item xs={11} lg={7} display="flex" justifyContent="center">
            <JobOfferDescription jobOffer={jobOffer} />
          </Grid>
        </Grid>
      ) : (
        <LoaderScreen />
      )}
    </>
  );
}

export default JobOfferPage;
